const Blog = () => {


    // Add custom class to product grid in blog

    const allProductItems = document.querySelectorAll('.single-post .post-single-page .product-grid-item');

    if (allProductItems) {
        allProductItems.forEach(element => {
            element.classList.add('product-on-blog-count');
        });
    }

    // Add custom class to blog content links

    // Wybierz elementy z klasą '.single-post .wd-entry-content'
    const contentElements = document.querySelectorAll('.single-post .wd-entry-content');

    if(contentElements) {
        contentElements.forEach(element => {
            // Pobierz wszystkie linki wewnątrz elementu
            const links = element.querySelectorAll('a:not(.blog-products__item)');

            // Iteruj przez linki
            links.forEach(link => {
                // Sprawdź, czy część ścieżki URL jest równa jednej z podanych wartości
                const targetPaths = [
                    '/p/opaska-sos-dla-osob-aktywnych-locon-life-plus-z-usluga-teleopieki/', 
                    '/p/opaska-sos-dla-osob-wymagajacych-stalej-opieki-locon-life-z-usluga-teleopieki/', 
                    '/p/lokalizator-gps-dla-kota-bz-02/',
                    '/p/lokalizator-gps-dla-psa-bz-02/',
                    '/p/lokalizator-gps-do-samochodu-ba-02-z-rocznym-pakietem-danych/',
                    '/p/smartwatch-locon-watch-lite/',
                    '/p/smartwatch-locon-watch-video/',
                    '/p/wodoodporny-lokalizator-gps-dla-kota-locon-cat-mini/',
                    '/p/wodoodporny-lokalizator-gps-dla-psa-locon-dog-mini/',
                ];
                const linkPath = link.pathname; // Pobierz część ścieżki URL linku

                if (targetPaths.includes(linkPath)) {
                    // Dodaj klasę do znalezionego linku
                    link.classList.add('product-links-inside-blog');
                }
            });
        });
    }

}

export default Blog;